import { useState } from 'react';

export type MapLayerOption = 'streets' | 'hybrid' | 'terrain';

export const MAP_STYLES: Record<MapLayerOption, string> = {
  streets: 'mapbox://styles/mapbox/streets-v12',
  hybrid: 'mapbox://styles/mapbox/satellite-streets-v12',
  terrain: 'mapbox://styles/mapbox/outdoors-v12',
};

export function useMapSettings() {
  const [layer, setLayer] = useState<MapLayerOption>('streets');
  const [brightness, setBrightness] = useState(100);

  return {
    layer,
    setLayer,
    brightness,
    setBrightness,
    mapStyle: MAP_STYLES[layer],
  };
}
